"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var date_range_picker_styles_1 = require("./date-range-picker.styles");
var date_helpers_1 = require("../../dates/date-helpers");
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var DateRangePickerRanges = function (_a) {
    var onChange = _a.onChange;
    var getTranslation = use_translations_hook_1.default().getTranslation;
    var setRange = function (numberOfDays) {
        onChange({ from: date_helpers_1.subtractDays(new Date(), numberOfDays + 1), to: date_helpers_1.subtractDays(new Date(), 1) });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(date_range_picker_styles_1.PickerLink, { "data-test-id": "date-picker-24h", onClick: function () { return onChange({ from: date_helpers_1.subtractDays(new Date(), 1), to: date_helpers_1.subtractDays(new Date(), 1) }); } }, getTranslation('DATE_RANGE_PICKER:YESTERDAY')),
        react_1.default.createElement(date_range_picker_styles_1.PickerLink, { "data-test-id": "date-picker-7d", onClick: function () { return setRange(7); } }, getTranslation('DATE_RANGE_PICKER:LAST_WEEK')),
        react_1.default.createElement(date_range_picker_styles_1.PickerLink, { "data-test-id": "date-picker-30d", onClick: function () { return setRange(30); } }, getTranslation('DATE_RANGE_PICKER:LAST_MONTH')),
        react_1.default.createElement(date_range_picker_styles_1.PickerLink, { "data-test-id": "date-picker-90d", onClick: function () { return setRange(90); } }, getTranslation('DATE_RANGE_PICKER:LAST_THREE_MONTHS'))));
};
DateRangePickerRanges.displayName = 'DateRangePickerRanges';
exports.default = DateRangePickerRanges;
